import { useState } from "react";
import BackButton from "../../../../components/BackButton";
import InputField from "../../../../components/InputField";
import PersonIcon from "@mui/icons-material/Person";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import "../../Common/form.css";
import "../../Admin/MasterData/vendorform.css";
 
const ClientOnboardingView = () => {
  const [submitError, setSubmitError] = useState("");
 
  // =================================================
  // CLIENT DATA
  // Replace this object with API response
  // =================================================
 
  const client = {
    organisation_name: "ABC Private Limited",
    organisation_type: "Vendor & Service Provider",
    gst_tan_no: "07ABCDE1234F1Z5",
    pan_no: "ABCDE1234F",
    company_cin_no: "U12345DL2020PTC123456",
    iec_no: "0512345678",
    name_of_business: "ABC Business Solutions",
 
    // =================================================
    // REGISTERED ADDRESS
    // =================================================
 
    flat_house_building: "123, ABC Tower",
    area_street_sector: "MG Road, Sector 10",
    country: "India",
    state: "Delhi",
    pincode: "110001",
 
    // =================================================
    // POC 1
    // =================================================
 
    poc1_full_name: "Rahul Sharma",
    poc1_designation: "Director",
    poc1_email: "rahul@example.com",
    poc1_mobile: "9876543210",
    poc1_telephone: "01123456789",
    poc1_extension: "101",
 
    // =================================================
    // POC 2
    // =================================================
 
    poc2_full_name: "Amit Kumar",
    poc2_designation: "Manager",
    poc2_email: "amit@example.com",
    poc2_mobile: "9876543211",
    poc2_telephone: "01123456780",
    poc2_extension: "102",
 
    // =================================================
    // DOCUMENTS
    // =================================================
 
    documents: {
      cin_certificate: {
        name: "ABC-CIN-Certificate.pdf",
        url: "/uploads/ABC-CIN-Certificate.pdf",
      },
 
      gstn: {
        name: "ABC-GST-Certificate.pdf",
        url: "/uploads/ABC-GST-Certificate.pdf",
      },
 
      pan: {
        name: "ABC-PAN.pdf",
        url: "/uploads/ABC-PAN.pdf",
      },
 
      cancelled_cheque: {
        name: "ABC-Cancelled-Cheque.pdf",
        url: "/uploads/ABC-Cancelled-Cheque.pdf",
      },
 
      iec: {
        name: "ABC-IEC-Certificate.pdf",
        url: "/uploads/ABC-IEC-Certificate.pdf",
      },
    },
  };
 
  // =================================================
  // DOCUMENT LIST
  // =================================================
 
  const documentList = [
    {
      name: "cin_certificate",
      label: "CIN Certificate",
      description: "Company incorporation certificate",
    },
    {
      name: "gstn",
      label: "GSTN",
      description: "GST registration certificate",
    },
    {
      name: "pan",
      label: "PAN",
      description: "Company PAN document",
    },
    {
      name: "cancelled_cheque",
      label: "Cancelled Cheque",
      description: "Company bank account cheque",
    },
    {
      name: "iec",
      label: "IEC Certificate",
      description: "IEC Certificate",
    },
  ];
 
  // =================================================
  // VIEW DOCUMENT
  // =================================================
 
  const handleViewDocument = async (document) => {
    if (!document?.url) {
      setSubmitError("Document is not available.");
      return;
    }
 
    try {
      setSubmitError("");
 
      // -------------------------------------------------
      // Open blank tab immediately.
      // This avoids popup blocker issues caused by
      // opening the tab after an async fetch.
      // -------------------------------------------------
 
      const newTab = window.open(
        "",
        "_blank",
      );
 
      if (!newTab) {
        setSubmitError(
          "Unable to open document. Please allow pop-ups for this site.",
        );
 
        return;
      }
 
      // Show temporary loading message
      newTab.document.write(`
        <html>
          <head>
            <title>Opening PDF...</title>
            <style>
              body {
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100vh;
                font-family: Arial, sans-serif;
                color: #444;
              }
            </style>
          </head>
          <body>
            Opening document...
          </body>
        </html>
      `);
 
      // -------------------------------------------------
      // Fetch PDF
      // -------------------------------------------------
 
      const response = await fetch(document.url);
 
      if (!response.ok) {
        throw new Error(
          `Unable to fetch PDF. Status: ${response.status}`,
        );
      }
 
      const blob = await response.blob();
 
      // -------------------------------------------------
      // Ensure PDF MIME type
      // -------------------------------------------------
 
      const pdfBlob = new Blob([blob], {
        type: "application/pdf",
      });
 
      // -------------------------------------------------
      // Create temporary URL
      // -------------------------------------------------
 
      const fileUrl =
        URL.createObjectURL(pdfBlob);
 
      // -------------------------------------------------
      // Navigate opened tab to PDF
      // -------------------------------------------------
 
      newTab.location.href = fileUrl;
 
      // -------------------------------------------------
      // Cleanup object URL
      // -------------------------------------------------
 
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 60000);
    } catch (err) {
      console.error(
        "Unable to preview PDF:",
        err,
      );
 
      setSubmitError(
        "Unable to preview this PDF.",
      );
    }
  };
 
  return (
    <>
      <BackButton />
 
      <div className="vendor-master-page">
        {/* =================================================
            SUBMIT / DOCUMENT ERROR
        ================================================== */}
 
        {submitError && (
          <div
            className="alert alert-danger vendor-error"
            role="alert"
          >
            {submitError}
          </div>
        )}
 
        {/* =================================================
            01 COMPANY DETAILS
        ================================================== */}
 
        <fieldset className="vendor-section mt-4">
          <legend className="vendor-section-legend">
            <span className="vendor-section-icon">
              <PersonIcon fontSize="small" />
            </span>
 
            <span className="vendor-section-title">
              Company Details
            </span>
          </legend>
 
          <p className="vendor-section-description">
            Company registration and address
            information.
          </p>
 
          <div className="vendor-section-body">
            {/* =================================================
                ORGANISATION INFORMATION
            ================================================== */}
 
            <div className="row g-3 mb-3">
              {/* ORGANISATION NAME */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Organisation Name"
                  name="organisation_name"
                  value={
                    client.organisation_name || ""
                  }
                  readOnly
                />
              </div>
 
              {/* ORGANISATION TYPE */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Organisation Type"
                  name="organisation_type"
                  value={
                    client.organisation_type || ""
                  }
                  readOnly
                />
              </div>
 
              {/* GST/TAN */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="GST/TAN No."
                  name="gst_tan_no"
                  value={
                    client.gst_tan_no || ""
                  }
                  readOnly
                />
              </div>
 
              {/* PAN */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="PAN No."
                  name="pan_no"
                  value={
                    client.pan_no || ""
                  }
                  readOnly
                />
              </div>
 
              {/* CIN */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Company CIN No."
                  name="company_cin_no"
                  value={
                    client.company_cin_no || ""
                  }
                  readOnly
                />
              </div>
 
              {/* IEC */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="IEC No."
                  name="iec_no"
                  value={
                    client.iec_no || ""
                  }
                  readOnly
                />
              </div>
 
              {/* NAME OF BUSINESS */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Name of Business"
                  name="name_of_business"
                  value={
                    client.name_of_business || ""
                  }
                  readOnly
                />
              </div>
            </div>
 
            {/* =================================================
                REGISTERED ADDRESS
            ================================================== */}
 
            <div className="vendor-subsection">
              <div className="vendor-subsection-title">
                Registered Address
              </div>
 
              <div className="row g-3">
                {/* FLAT / HOUSE */}
 
                <div className="col-12 col-lg-6">
                  <InputField
                    label="Flat/House No./Building/Company/Apartment"
                    name="flat_house_building"
                    value={
                      client.flat_house_building ||
                      ""
                    }
                    readOnly
                  />
                </div>
 
                {/* AREA / STREET */}
 
                <div className="col-12 col-lg-6">
                  <InputField
                    label="Area/Street/Sector/Town/Village"
                    name="area_street_sector"
                    value={
                      client.area_street_sector ||
                      ""
                    }
                    readOnly
                  />
                </div>
 
                {/* COUNTRY */}
 
                <div className="col-12 col-md-4">
                  <InputField
                    label="Country"
                    name="country"
                    value={
                      client.country || ""
                    }
                    readOnly
                  />
                </div>
 
                {/* STATE */}
 
                <div className="col-12 col-md-4">
                  <InputField
                    label="State"
                    name="state"
                    value={
                      client.state || ""
                    }
                    readOnly
                  />
                </div>
 
                {/* PINCODE */}
 
                <div className="col-12 col-md-4">
                  <InputField
                    label="Pincode"
                    name="pincode"
                    value={
                      client.pincode || ""
                    }
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
 
        {/* =================================================
            02 CONTACT DETAILS
        ================================================== */}
 
        <fieldset className="vendor-section mt-4">
          <legend className="vendor-section-legend">
            <span className="vendor-section-icon">
              <ContactMailIcon fontSize="small" />
            </span>
 
            <span className="vendor-section-title">
              Contact Details
            </span>
          </legend>
 
          <p className="vendor-section-description">
            Authorised and assigned points of
            contact.
          </p>
 
          <div className="vendor-section-body">
            {/* =================================================
                POC 1
            ================================================== */}
 
            <div className="vendor-poc-header">
              <div className="vendor-poc-heading">
                <span className="vendor-poc-label">
                  POC - 1
                </span>
 
                <span className="vendor-poc-badge authorised">
                  Authorised
                </span>
              </div>
            </div>
 
            <div className="row g-3">
              {/* FULL NAME */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Full Name"
                  name="poc1_full_name"
                  value={
                    client.poc1_full_name ||
                    ""
                  }
                  readOnly
                />
              </div>
 
              {/* DESIGNATION */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Designation"
                  name="poc1_designation"
                  value={
                    client.poc1_designation ||
                    ""
                  }
                  readOnly
                />
              </div>
 
              {/* EMAIL */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mail ID"
                  name="poc1_email"
                  value={
                    client.poc1_email || ""
                  }
                  readOnly
                />
              </div>
 
              {/* MOBILE */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mobile No."
                  name="poc1_mobile"
                  value={
                    client.poc1_mobile || ""
                  }
                  readOnly
                />
              </div>
 
              {/* TELEPHONE */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Telephone No."
                  name="poc1_telephone"
                  value={
                    client.poc1_telephone ||
                    ""
                  }
                  readOnly
                />
              </div>
 
              {/* EXTENSION */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Extension No."
                  name="poc1_extension"
                  value={
                    client.poc1_extension ||
                    ""
                  }
                  readOnly
                />
              </div>
            </div>
 
            {/* =================================================
                POC 2
            ================================================== */}
 
            <div className="vendor-poc-header">
              <div className="vendor-poc-heading">
                <span className="vendor-poc-label">
                  POC - 2
                </span>
 
                <span className="vendor-poc-badge assigned">
                  Assigned
                </span>
              </div>
            </div>
 
            <div className="row g-3">
              {/* FULL NAME */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Full Name"
                  name="poc2_full_name"
                  value={
                    client.poc2_full_name ||
                    ""
                  }
                  readOnly
                />
              </div>
 
              {/* DESIGNATION */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Designation"
                  name="poc2_designation"
                  value={
                    client.poc2_designation ||
                    ""
                  }
                  readOnly
                />
              </div>
 
              {/* EMAIL */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mail ID"
                  name="poc2_email"
                  value={
                    client.poc2_email || ""
                  }
                  readOnly
                />
              </div>
 
              {/* MOBILE */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mobile No."
                  name="poc2_mobile"
                  value={
                    client.poc2_mobile || ""
                  }
                  readOnly
                />
              </div>
 
              {/* TELEPHONE */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Telephone No."
                  name="poc2_telephone"
                  value={
                    client.poc2_telephone ||
                    ""
                  }
                  readOnly
                />
              </div>
 
              {/* EXTENSION */}
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Extension No."
                  name="poc2_extension"
                  value={
                    client.poc2_extension ||
                    ""
                  }
                  readOnly
                />
              </div>
            </div>
          </div>
        </fieldset>
 
        {/* =================================================
            03 SUPPORTING DOCUMENTS
        ================================================== */}
 
        <fieldset className="vendor-section mt-4">
          <legend className="vendor-section-legend">
            <span className="vendor-section-icon">
              <ContactSupportIcon fontSize="small" />
            </span>
 
            <span className="vendor-section-title">
              Supporting Docs Checklist
            </span>
          </legend>
 
          <p className="vendor-section-description">
            Uploaded supporting documents.
          </p>
 
          <div className="vendor-section-body">
            <div className="row g-3 mb-3">
              {documentList.map((doc) => {
                const uploadedFile =
                  client.documents?.[doc.name];
 
                return (
                  <div
                    className="col-12 col-md-6 col-lg-4"
                    key={doc.name}
                  >
                    <div
                      className={`vendor-document-upload-card ${
                        uploadedFile
                          ? "uploaded"
                          : ""
                      }`}
                    >
                      {/* =================================================
                          DOCUMENT INFORMATION
                      ================================================== */}
 
                      <div className="vendor-document-info">
                        <div
                          className={`vendor-document-icon ${
                            uploadedFile
                              ? "success"
                              : ""
                          }`}
                        >
                          {uploadedFile
                            ? "✓"
                            : "PDF"}
                        </div>
 
                        <div className="vendor-document-title">
                          <span>
                            {doc.label}
                          </span>
 
                          <small>
                            {doc.description}
                          </small>
                        </div>
                      </div>
 
                      {/* =================================================
                          ACTIONS
                      ================================================== */}
 
                      {uploadedFile && (
                        <div className="vendor-document-actions">
                          <button
                            type="button"
                            className="vendor-view-btn"
                            onClick={() =>
                              handleViewDocument(
                                uploadedFile,
                              )
                            }
                          >
                            View
                          </button>
                        </div>
                      )}
 
                      {/* =================================================
                          FILE NAME
                      ================================================== */}
 
                      {uploadedFile && (
                        <div
                          className="vendor-file-name"
                          title={
                            uploadedFile.name
                          }
                        >
                          📄{" "}
                          {uploadedFile.name}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};
 
export default ClientOnboardingView;